import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M65.1377 50.0003V50.0008C65.1377 52.096 64.3154 54.0638 62.8223 55.5413L41.3335 76.7967C39.8413 78.2728 37.4355 78.2596 35.9595 76.7674C34.4844 75.2757 34.4971 72.8694 35.9888 71.3934L57.4775 50.138C57.5058 50.1102 57.5381 50.0687 57.5381 50.0003C57.5381 49.9314 57.5049 49.8899 57.4766 49.8616L35.9888 28.6067C34.4971 27.1302 34.4839 24.7239 35.9595 23.2337C37.4355 21.7415 39.8413 21.7278 41.3335 23.2044L62.8213 44.4593C64.3154 45.9368 65.1377 47.9046 65.1377 50.0003Z'

const IconCaretRight: FC<IconProps> = props => (
  <SvgIcon {...props} path={PATH} />
)

export default IconCaretRight
